import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  compDisableCls: {
    opacity: 0.9,
    pointerEvents: "none",
  },
  accowrapperReadOnly: {
    opacity: 0.9,
  },
  formOneWrapper: {},
  formOneLbl: {},
  textWrap: {
    float: "left",
    textAlign: "left",
    fontSize: "14px",
    width: "100%",
    margin: "5px 0 10px 0",
  },

  textWrapInput: {
    float: "left",
    textAlign: "left",
    fontSize: "14px",
    width: "100%",
    margin: "0px 0 10px 0",
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "10px 0 10px 0",
    minHeight: "20px",
  },

  formOneLblinputWrapper: {},

  formOneinputWrapper: {
    margin: "10px 0 10px 0",
    "& .MuiInputBase-root": {
      borderRadius: "4px",
      //border: '1px solid #c0c1c1',
      padding: "0px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .MuiSvgIcon-root": {
      color: "#000 !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "12px 5px",
      textAlign: "left",
      fontSize: "14px",
    },
    "& .MuiInput-root": {
      position: "relative",
      width: "100%",
      border: "1px solid #ccc !important",
      borderRadius: "4px",
      padding: "4px 0",
      background: "#f7fcff",
      float: "left",
    },

    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "unset",
      //margin: '2px',
      width: "100%",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "13px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    // "& input":{
    //              borderRadius: '4px',
    //              border: '1px solid #c0c1c1',
    //              padding: '8px 0',
    //              width:'100%',
    //             background:'#f7fcff',
    //              float: 'left',
    //          },
    "& select": {
      borderRadius: "4px",
      border: "1px solid #c0c1c1",
      padding: "12px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .makeStyles-root-25 .MuiIconButton-root": {
      padding: "4px 0",
    },
    "& .MuiList-padding": {
      paddingTop: "10px !important",
    },
  },

  inputWrapper_Req: {
    margin: "10px 0 10px 0",
    "& .MuiSvgIcon-root": {
      color: "#333 !important",
    },
    "& .MuiChip-clickable": {
      margin: "-5px 0 0 3px !important",
    },

    "& .MuiInputBase-root": {
      borderRadius: "4px",
      //border: '1px solid #c0c1c1',
      padding: "0px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .MuiOutlinedInput-input": {
      // padding:'12px 5px',
      // borderRight:'5px solid #ed1c24',
      // borderRadius:'0 4px 4px 0',
      // textAlign: 'left',
      // fontSize: '14px',

      padding: "10px 5px",
      maxHeight: "20px",
      textAlign: "left",
      borderRight: "5px solid #ed1c24",
      borderRadius: "0 4px 4px 0",
    },
    "& .MuiInput-root": {
      position: "relative",
      width: "100%",
      border: "1px solid #ed1c24 !important",
      borderRadius: "4px",
      padding: "4px 0",
      background: "#f7fcff",
      float: "left",
      borderRight: "5px solid #ed1c24 !important",
    },
    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "unset",
      margin: "2px",
      width: "100%",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']":
      {
        paddingRight: "0px",
      },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "13px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    "& select": {
      borderRadius: "4px",
      border: "1px solid #c0c1c1",
      padding: "12px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
      borderRight: "5px solid #ed1c24 !important",
    },
    "& .makeStyles-root-25 .MuiIconButton-root": {
      padding: "4px 0",
    },
    "& .MuiList-padding": {
      paddingTop: "10px !important",
    },
  },

   inputWrapper: {
    margin: "10px 0 10px 0",
    //float: "left",
    width: "100%",
    "& .MuiInputBase-root": {
      borderRadius: "4px",
      //border: '1px solid #c0c1c1',
      padding: "0px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 5px",
      textAlign: "left",
      maxHeight: "20px",
    },
    "& .MuiInput-root": {
      position: "relative",
      width: "100%",
      border: "1px solid #ccc !important",
      borderRadius: "4px",
      padding: "4px 0",
      background: "#f7fcff",
      float: "left",
    },

    "& .MuiTextField-root": {
      fontSize: "2px",
      background: "#fff",
      padding: "0 0 0 0",
      borderRadius: "5px",
      border: "unset",
      //margin: '2px',
      width: "100%",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "1px solid #ccc",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
      padding: "0px 0 0 0",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        padding: "13px 4px",
        fontSize: "12px",
      },
    "& .makeStyles-filterSection-149 .MuiTextField-root": {
      border: "1px solid #333",
    },
    "& .makeStyles-root-139 .MuiIconButton-root": {
      padding: "0px 0",
      margin: "0px 0",
    },
    // "& input":{
    //              borderRadius: '4px',
    //              border: '1px solid #c0c1c1',
    //              padding: '8px 0',
    //              width:'100%',
    //             background:'#f7fcff',
    //              float: 'left',
    //          },
    "& select": {
      borderRadius: "4px",
      border: "1px solid #c0c1c1",
      padding: "12px 0",
      width: "100%",
      background: "#f7fcff",
      float: "left",
    },
    "& .makeStyles-root-25 .MuiIconButton-root": {
      padding: "4px 0",
    },
    "& .MuiList-padding": {
      paddingTop: "10px !important",
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "#7f7f7f",
    },
    "& .MuiChip-root.Mui-disabled": {
      color: "#7f7f7f",
    },
  },
  
  switchDiv: {
    float: "left",
    margin: "-10px 0 0 0",
  },

  accHeader: {
    background: "#7E7E7E",
    color: "#fff",
    textTransform: "uppercase",
    height: "33px",
    minHeight: "unset",
    "& .MuiTypography-body1": {
      fontSize: "14px",
      fontWeight: "bold",
    },
  },
  accwrapper: {
    "& .MuiSvgIcon-root": {
      color: "#fff",
    },
  },
  formTwoLbl: {
    textAlign: "left",
    float: "left",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
    margin: "0 0 6px 0",
  },

  rejectedLbl: {
    textAlign: "left",
    float: "left",
    fontSize: "12px",
    fontWeight: "bold",
    textTransform: "uppercase",
  },

  rejectedBox: {
    border: "1px solid #f52525",
    borderRadius: "5px",
    background: "#e8a9a9",
    fontSize: "10px",
    fontWeight: "bold",
    padding:"2px 8px",
    marginLeft: "8px",
  }, 

  // BUTTONS
  addBtnWrapper: {
    float: "left",
    //margin: '-18px 0px 0 10px',
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff !important",
      borderRadius: "20px",
    },
    "& .MuiSvgIcon-root": {
      color: "#fff !important",
    },
    "& .MuiButton-text": {
      padding: "4px 6px",
    },
    "& .MuiButton-root:hover": {
      background: "#00b50a !important",
      fontSize: "12px",
      color: "#fff",
    },
  },

  greenBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#19C626 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      color: "#fff",
      fontSize: "12px",
      background: "#00b50a !important",
      borderRadius: "20px",
      padding: "5px 17px 5px 12px",
    },
  },

  grayBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
    },
  },
  redBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#f00 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
    },
  },
  blueBtnWrapper: {
    float: "right",
    margin: "-18px 0px 0 10px",
    [theme.breakpoints.down("sm")]: {
      margin: "0px 0px 5px 10px",
    },
    "& button": {
      background: "#0faade !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
      fontWeight: "bold",
    },
    "& .MuiButton-root:hover": {
      background: "#333 !important",
      fontSize: "12px",
      color: "#fff",
      borderRadius: "20px",
      padding: "5px 25px",
    },
  },

  fileWrapper: {
    margin: "20px 0 0 0",
    "& input": {
      background: "#ccc",
    },
    "& input[type='file']": {
      float: "left",
      padding: "10px 2px",
      background: "#f7fcff",
      borderRadius: "4px",
      border: "1px solid #ccc",
      width: "51%",
    },
    "& .MuiButton-contained.Mui-disabled": {
      backgroundColor: "#05ae2a !important",
      color: "#fff",
      padding: "2px 10px !important",
      margin: "8px 0 0 5px",
      float: "left",
    },
    "& .MuiButton-containedPrimary": {
      backgroundColor: "#05ae2a !important",
      color: "#fff",
      padding: "2px 10px !important",
      margin: "8px 0 0 5px",
      float: "left",
    },
    "& a": {
      background: "#00a4dd",
      textDecoration: "none",
      color: "#fff",
      margin: "7px 0 0 5px",
      padding: "6px 7px 7px 6px",
      borderRadius: "4px",
      textTransform: "uppercase",
      fontSize: "14px",
      float: "left",
    },
  },

  popUpOuter: {
    "& .Mui-disabled": {
      opacity: "0.6 !important",
      color: "#fff  !important",
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "600px",
      overflow: "initial",
    },
    "& .MuiDialogTitle-root ": {
      flex: "0 0 auto",
      margin: "0",
      position: "relative",
      padding: "16px 24px",
      //z-index: '1',
    },
    "& .MuiOutlinedInput-input": {
      float: "left !important",
      width: "100% !important",
      padding: "10px 2px !important",
      background: "#f7fcff",
      borderRadius: "4px",
    },
  },

  NoPopWrapper: {
    "& .MuiOutlinedInput-input": {
      float: "left",
      width: "100%",
      padding: "10px 0 10px 2px",
      background: "#f7fcff",
      borderRadius: "4px",
    },
    "& .MuiFormControl-root": {
      margin: "0 10px 10px 0",
    },
  },
  popUpAddBtn: {
    "& .MuiSvgIcon-root": {
      color: "#28b600",
      float: "left",
    },
  },

  popUpDeleteBtn: {
    "& .MuiSvgIcon-root": {
      color: "#b60000",
      float: "left",
    },
  },
  listWrapper: {
    "& .MuiTypography-displayBlock": {
      fontSize: "14px",
      color: "#000",
    },
    "& ul": {
      // background: '#fafafa !important',
      // padding: '0 !important',
    },
    "& li": {
      borderBottom: "1px solid #ccc",
    },
  },
  popUpLBL: {
    textTransform: "uppercase",
    fontSize: "12px",
    margin: "0 2px 0 0",
  },

  popUpHeader: {
    backgroundImage: "linear-gradient(to right, #890e34, #ce0623)",
    padding: "14px 12px 10px 24px !important",
    borderRadius: "0px 0px 0 0",
    "& h2": {
      color: "#fff",
      fontWeight: "normal",
      textTransform: "uppercase",
      position: "relative",
    },
  },

  closeIcon: {
    float: "right",
    cursor: "pointer",
    position: "absolute",
    top: "-18px",
    right: "-17px",
    // z-index: 999999;
    "& .MuiSvgIcon-root": {
      fontSize: "40px",
      color: "#eef0ff !important",
    },
  },

  tblContainer: {
    // maxHeight:'375px',
  },
  tblHeader: {
    "& th": {
      //  backgroundColor:'#fbfbfb',
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "12px",
      padding: "10px 5px !important",
      fontWeight: "bold",
    },
  },
  tblBody: {
    "& th": {
      backgroundColor: "#fff",
      color: "#000",
      textTransform: "uppercase",
      fontSize: "12px",
      padding: "6px 5px !important",
      fontWeight: "bold",
    },
    "& td": {
      color: "#000",
      backgroundColor: "#fff;",
      fontSize: "12px",
      padding: "6px 5px !important",
      /*textTransform: "uppercase",*/
      borderBottom: "1px solid #ededed !important",
    },
  },
  tblOuterBG: {
    maxWidth:"inherit",
    backgroundColor: "#fff;",
    padding: "10px",
    borderRadius: "15px",
  },

  /////////
  editBtn: {
    fontSize: "12px",
    color: "#0084ff",
    float: "left",

    "& .MuiSvgIcon-root": {
      fontSize: "28px !important",
      color: "#0084ff",
      float: "left",
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#0084ff !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  editBtnTxt: {
    color: "#0084ff",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
  },
  rejectBtn: {
    fontSize: "12px",
    color: "#EA1B1B",
    float: "right",

    "& .MuiSvgIcon-root": {
      fontSize: "32px !important",
      color: "#EA1B1B",
      float: "left",
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#EA1B1B !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },  
  rejectBtnTxt: {
    color: "#EA1B1B",
    float: "left",
    margin: "10px 0 0 0",
    textTransform: "uppercase",
    fontSize: "11px",
    fontWeight: "bold",
  },
  viewBtn: {
    fontSize: "12px",
    color: "#0faade",
    float: "right",

    "& .MuiSvgIcon-root": {
      fontSize: "32px !important",
      color: "#0faade",
      float: "left",
    },
    "& button": {
      background: "unset !important",
      border: "unset !important",
      color: "#0faade !important",
      padding: "0",
    },
    "& button:hover": {
      textDecoration: "none",
      cursor: "pointer !important",
    },
  },
  //  edited label style
  editedLabel: {
    border: "1px solid #FF9F07",
    borderRadius: "5px",
    background: "#FFEA91",
    fontSize: "10px",
    fontWeight: "bold",
    padding:"2px 8px",
    marginLeft: "8px",
  },
  addedStripe: {
    borderLeft: "4px solid #008900",
    marginTop: "2px",
    marginBottom: "2px",
    borderRadius: "5px",
  },
  deletedStripe: {
    borderLeft: "4px solid #d80000",
    marginTop: "2px",
    marginBottom: "2px",
    borderRadius: "5px",
  },
  modifiedStripe: {
    borderLeft: "4px solid #FF9F07",
    marginTop: "2px",
    marginBottom: "2px",
    borderRadius: "5px",
  },
  legendSection: {
    width: "100%",
    textAlign: "right",
  },
  legendLbl: {
    fontSize: "12px",
    marginLeft: "10px",
  },
  addLbl: {
    borderLeft: "3px solid #008900",
    height: "10px",
    width: "4px",
    marginRight: "10px",
  },
  deleteLbl: {
    borderLeft: "3px solid #d80000",
    height: "10px",
    width: "4px",
    marginRight: "10px",
  },
  modifiedLbl: {
    borderLeft: "3px solid #FF9F07",
    height: "10px",
    width: "4px",
    marginRight: "10px",
  },
  editedCell: {
    background: "#FFEA91 !important",
    borderRadius: "4px",
  },
  deletedDataRow: {
    "& td": {
      color: "#a3aba4 !important",
    },
  },
  helpLbl: {
    textAlign: 'left',
    float: 'left',
    fontSize: '12px',
    color: '#02268b',
    fontStyle: 'italic',
    width: '100%',
    margin: '0 0 2px 0',

  },
}));

export default useStyles;